// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__o5MAK","close":"style_close__qa+u-","overlay":"style_overlay__k7WYR"};